import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/MapboxGeocoder.module.scss';

class ReactMapboxAutocomplete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            errorMsg: '',
            queryResults: [],
            publicKey: this.props.publicKey,
            resetSearch: this.props.resetSearch ? this.props.resetSearch : false,
            openDropdown: false,
        };

        this.dropdownRef = createRef();
        this.inputRef = createRef();
    }

    timeout = 0;

    _updateQuery = event => {
        this.props.onChange(event.target.value);

        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
            const header = {'Content-Type': 'application/json'};
            let path = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + this.props.query + '.json?access_token=' + this.state.publicKey;

            this.props.params.forEach(param => {
                path += `&${param.type}=${param.value}`;
            });

            if (this.props.query.length > 2) {
                return fetch(path, {
                    headers: header,
                }).then(res => {
                    if (!res.ok) throw Error(res.statusText);
                    return res.json();
                }).then(json => {
                    this.setState({
                        error: false,
                        queryResults: json.features,
                        openDropdown: true,
                    });
                }).catch(() => {
                    this.setState({
                        error: true,
                        errorMsg: "We couldn't find any matching locations!",
                        queryResults: [],
                        openDropdown: false,
                    });
                })
            } else {
                this.setState({
                    error: false,
                    queryResults: [],
                    openDropdown: false,
                });
            }
        }, 500)
    };

    checkIfOutsideDropdown = e => {
        if (!this.state.openDropdown && this.inputRef.current && this.inputRef.current.contains(e.target)) {
            this.setState({
                openDropdown: true
            })
        } else if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
            this.setState({
                openDropdown: false,
            })
        }
    };

    componentDidMount() {
        window.addEventListener('click', this.checkIfOutsideDropdown);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.checkIfOutsideDropdown);
    }

    _resetSearch = () => {
        if (this.state.resetSearch) {
            this.setState({
                query: '',
                queryResults: [],
                openDropdown: false,
            });
        } else {
            this.setState({
                queryResults: [],
                openDropdown: false,
            });
        }
    }

    _onSuggestionSelect = event => {
        if (this.state.resetSearch === false) {
            // this.setState({query: event.target.getAttribute('data-suggestion')});
            this.props.onChange(event.target.getAttribute('data-suggestion'));
        }

        this.props.onSuggestionSelect(
            // event.target.getAttribute('data-suggestion'),
            event.target.getAttribute('data-lat'),
            event.target.getAttribute('data-lng'),
            // event.target.getAttribute('data-text'),
            event.target.getAttribute('data-place')
        )
    }

    render() {
        const containerClassName = classNames({
            [styles.container]: true,
            [this.props.divClass]: this.props.divClass,
        });

        return (
            <div className={containerClassName}>
                {this.props.children}
                <input placeholder={this.props.placeholder || 'Search'}
                       id={this.props.inputId}
                       onClick={this.props.inputOnClick}
                       onBlur={this.props.inputOnBlur}
                       onFocus={this.props.inputOnFocus}
                       className={this.props.inputClass}
                       onChange={this._updateQuery}
                       value={this.props.query}
                       type='text'
                       ref={this.inputRef}
                />
                <span>
                  <div ref={this.dropdownRef} style={(this.state.queryResults.length > 0 && this.state.openDropdown) || this.state.error ? {display: 'block'}
                      : {display: 'none'}}
                       onClick={this._resetSearch}>

                    {this.state.queryResults.map((place, i) => {
                        return (
                            <div onClick={this._onSuggestionSelect}
                                 key={i}
                                 data-place={JSON.stringify(place)}
                                 data-suggestion={place.place_name}
                                 data-lng={place.center[0]}
                                 data-lat={place.center[1]}
                                 data-text={place.text}>
                                {place.place_name}
                            </div>
                        )
                    })
                    }
                      {this.state.error && <div>{this.state.errorMsg}</div>}
                  </div>
            </span>
            </div>
        );
    }
}

ReactMapboxAutocomplete.defaultProps = {
    inputId: null,
    inputOnFocus: null,
    inputOnBlur: null,
    inputOnClick: null,
    params: [],
    publicKey: 'pk.eyJ1IjoiZGF2aWRnb2xkZW4iLCJhIjoiY2pwZW5oamdwMDIyejNrbzhrMGc4YzlqNiJ9.klBRb1BeqxvmJjqi9f-8yw',
};

ReactMapboxAutocomplete.propTypes = {
    divClass: PropTypes.string,
    inputId: PropTypes.string,
    inputOnFocus: PropTypes.func,
    inputOnBlur: PropTypes.func,
    inputOnClick: PropTypes.func,
    inputClass: PropTypes.string,
    publicKey: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSuggestionSelect: PropTypes.func.isRequired,
    country: PropTypes.string,
    params: PropTypes.array, // add optional query params, options include:
    // [ country, language, limit, reverseMode, routing, types ]
    // More info: https://www.mapbox.com/api-documentation/#retrieve-places-near-a-location
    // prop type is array of { type, value } objects, where value is consistent with Mapbox API requirements
    query: PropTypes.string,
    resetSearch: PropTypes.bool
}

export default ReactMapboxAutocomplete;
